const baseApiUrl = process.env.VUE_APP_MAIN_DOMAIN_URL

export function requestError (code, unknown = false) {
  const authFailure = ['authentication_required', 'account_inactive'].includes(code)
  let message = 'Не вдалося виконати запит. Перевірте з’єднання та повторіть дію.'
  if (authFailure) message = 'Сесія недійсна. Увійдіть повторно. Введені дані не видалено.'
  if (code === 'organization_required') message = 'Спочатку оберіть організацію. Повторіть оформлення.'
  if (code === 'incompatible_backend') message = 'Відповідь сервера несумісна з оформленням. Зверніться до підтримки.'
  if (unknown) message = 'Результат оформлення невідомий. Дані збережено. Перевірте, чи створено документ, перед повторним відправленням.'
  const error = new Error(message)
  error.code = code
  error.authFailure = authFailure
  error.unknownOutcome = unknown
  return error
}

const positiveId = value => Number.isInteger(value) && value > 0 && value <= 4294967295

function validateOrganization (data) {
  if (!data || typeof data.is_employee !== 'boolean' || !Array.isArray(data.organizations) ||
      !(data.organization_id === null || positiveId(data.organization_id)) || data.csrf_token !== null) {
    throw requestError('incompatible_backend')
  }
  const ids = new Set()
  for (const item of data.organizations) {
    if (!item || !positiveId(item.id) || typeof item.name !== 'string' || !item.name.trim() || ids.has(item.id)) {
      throw requestError('incompatible_backend')
    }
    ids.add(item.id)
  }
  if (data.organization_id !== null && !ids.has(data.organization_id)) throw requestError('incompatible_backend')
  return data
}

export function buildRequestUrl (route, auth) {
  if (!auth || !/^[1-9][0-9]*$/.test(String(auth.customerId)) || typeof auth.token !== 'string' || !auth.token) {
    throw requestError('authentication_required')
  }
  let url
  try {
    url = new URL(baseApiUrl)
  } catch (_) {
    throw requestError('incompatible_backend')
  }
  // Keep the configured host and installation path; replace the legacy api/app query.
  if (!/\/index\.php$/.test(url.pathname) || !['http:', 'https:'].includes(url.protocol) || url.username || url.password) {
    throw requestError('incompatible_backend')
  }
  url.search = ''
  url.hash = ''
  url.searchParams.set('route', route)
  url.searchParams.set('customer_id', auth.customerId)
  url.searchParams.set('token', auth.token)
  return url.toString()
}

export async function requestApi (route, auth, body, kind = 'organization') {
  const url = buildRequestUrl(route, auth)
  const controller = new AbortController()
  let timedOut = false
  const timeout = setTimeout(() => {
    timedOut = true
    controller.abort()
  }, 20000)
  try {
    const response = await fetch(url, {
      method: body === undefined ? 'GET' : 'POST',
      cache: 'no-store',
      credentials: 'omit',
      redirect: 'error',
      signal: controller.signal,
      ...(body === undefined ? {} : { body })
    })
    let result
    try {
      result = await response.json()
    } catch (_) {
      throw requestError('incompatible_backend', kind !== 'organization')
    }
    if (!response.ok || !result || result.status !== 'success') {
      const code = result && typeof result.error === 'string' ? result.error : 'incompatible_backend'
      const unknown = kind !== 'organization' && (response.status >= 500 ||
        (response.ok && code === 'incompatible_backend') ||
        code === 'order_confirmation_incomplete' || (result && result.data && result.data.outcome === 'unknown'))
      throw requestError(code, unknown)
    }
    if (kind === 'organization') return validateOrganization(result.data)
    const field = kind === 'service' ? 'application_id' : 'order_id'
    if (!result.data || !positiveId(result.data[field]) ||
        !(result.data.organization_id === null || positiveId(result.data.organization_id))) {
      throw requestError('incompatible_backend', true)
    }
    return result.data
  } catch (error) {
    if (error.code) throw error
    throw requestError(timedOut ? 'timeout' : 'transport_error', kind !== 'organization')
  } finally {
    clearTimeout(timeout)
  }
}
